import { render, staticRenderFns } from "./ButtonMealRecipeVideo.vue?vue&type=template&id=f1472e3a"
import script from "./ButtonMealRecipeVideo.vue?vue&type=script&lang=js"
export * from "./ButtonMealRecipeVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports